var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-page-blank',{attrs:{"hasTitle":""},on:{"init":_vm.handleInit}},[_c('List',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }